import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
export default class Frame2 extends Component{
    constructor(props){
        super(props);
    }

    render() {
        return <iframe className="tutorIFrame"/>
    }

    componentDidMount() {
        let domNode = ReactDOM.findDOMNode(this);
        let iframeWindow = domNode.contentWindow;
        iframeWindow.postBenchmarkResult = this.props.callback;
        iframeWindow.getData = this.props.getData;

        let doc = domNode.contentDocument;
        doc.open();
        doc.write(this.props.htmlContent);
        doc.close();
        //ReactDOM.findDOMNode(this).addEventListener('load', this.props.testCallback);
        if(!iframeWindow.postBenchmarkResult){
            iframeWindow.postBenchmarkResult = this.props.callback;
        }
        if(!iframeWindow.getData){
            iframeWindow.getData = this.props.getData;
        }
    }

    componentDidUpdate(){
        let domNode = ReactDOM.findDOMNode(this);
        let ifreamWindow = domNode.contentWindow;
        ifreamWindow.postBenchmarkResult = this.props.callback;
        ifreamWindow.getData = this.props.getData;
    }
}



// WEBPACK FOOTER //
// ./client/components/Frame2.js